<script lang="ts"></script>

<template>
  <!-- <UNotifications /> -->
  <Header />
  <slot />
  <Footer />
  <!-- <UModals /> -->
  <!-- <USlideovers /> -->
</template>
